import { TUserStudentScholarity } from "@bsm/graphql";
import moment from "moment";

export const useDateScholarity = (props: Props) => {
    const [startYear, endYear] = props?.schoolYear.split("-").map(Number);

    const startMonth = moment(props?.monthBegin, "M").locale("fr").format("MMMM");
    const endMonth = moment(props?.monthEnd, "M").locale("fr").format("MMMM");

    return {
        start: `${startMonth} ${startYear}`,
        end: `${endMonth} ${endYear}`
    }
}


type Props = Partial<TUserStudentScholarity>